'use client';

import { forwardRef, type ReactNode } from 'react';
import { cn } from '@/app/utils';

interface FilterButtonProps {
  children: ReactNode;
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
}

export const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  ({ children, isActive = false, onClick, className }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          'flex h-8 max-w-32 cursor-pointer items-center gap-2 rounded-8 bg-system-white10 px-3 text-sm',
          isActive && 'bg-system-white24',
          className,
        )}
        onClick={onClick}
      >
        {children}
      </span>
    );
  },
);

FilterButton.displayName = 'FilterButton';
